﻿/**
 * Created by pejs on 08.06.2017.
 */

/*global define, $*/
import creator from './elementCreator';
"use strict";
var privateFns;
var kommuneplanDokument = "https://www.oslo.kommune.no/getfile.php/1374702/Innhold/Politikk%20og%20administrasjon/Politikk/Kommuneplan/Ny%20kommuneplan%202015/Kommuneplan%202015%20del%202%20justert%2031.01.2017.pdf";
privateFns = {
	"1001-1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Bebyggelse og anlegg (nåværende)"}));
		el.appendChild(creator.createParagraph({text: "Området er avsatt til bebyggelse og anlegg. Dette kan være boligbebyggelse, fritidsbebyggelse, sentrumsformål, kjøpesenter, forretninger, bebyggelse for offentlig eller privat tjenesteyting, fritids- og turistformål, råstoffutvinning, næringsbebyggelse, idrettsanlegg, andre typer anlegg, uteoppholdsarealer og grav- og urnelunder."}));

		return el;
	},
	"1001-2": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Bebyggelse og anlegg (fremtidig)"}));
		el.appendChild(creator.createParagraph({text: "Området er avsatt til fremtidig bebyggelse og anlegg. Det kan være boligbebyggelse, fritidsbebyggelse, sentrumsformål, kjøpesenter, forretninger, bebyggelse for offentlig eller privat tjenesteyting, fritids- og turistformål, råstoffutvinning, næringsbebyggelse, idrettsanlegg, andre typer anlegg, uteoppholdsarealer og grav- og urnelunder. De fleste av disse områdene er utviklingsområder som er inndelt i seks kategorier og merket U–U5:"}));
		el.appendChild(creator.createUl({listItems: [
			"utviklingsområder ytre by (U)",
			"sentrum (U1)",
			"sentrumsranden og knutepunkter (U2)",
			"Akerselva og andre områder (U3)",
			"strøksgater (U4)",
			"institusjonelle utviklingsområder (U5)"
		]}));
		el.appendChild(creator.createParagraph({text: "I tillegg viser plankartet transformasjonsområder i indre by, merket T, og områder som ikke er merket med bokstav. De umerkede områdene er tidligere uregulerte."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om bebyggelse og anlegg (fremtidig):"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=26' target='_blank'>§ 11 i kommuneplanen <i class='icon-new-window'></i></a>",
			"<a href='" + kommuneplanDokument + "#page=20' target='_blank'>§ 3.2 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"2020-1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Eksisterende bane"}));
		el.appendChild(creator.createParagraph({text: "Dette området er avsatt til eksisterende bane."}));

		return el;
	},
	"2040-1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Eksisterende havn"}));
		el.appendChild(creator.createParagraph({text: "Dette området er avsatt til eksisterende havn."}));

		return el;
	},
	"2040-2": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Fremtidig havn"}));
		el.appendChild(creator.createParagraph({text: "Dette området er avsatt til fremtidig havn."}));

		return el;
	},
	"2070-2": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Fremtidig kolletivknutepunkt"}));
		el.appendChild(creator.createParagraph({text: "Dette området er avsatt til fremtidig kollektivknutepunkt."}));

		return el;
	},
	"3001-1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Eksisterende grønnstruktur"}));
		el.appendChild(creator.createParagraph({text: "Dette er områder skal tilrettelegges for opplevelse, rekreasjon, lek og fysisk aktivitet for allmennheten.  Dette kan være naturområder, turdrag, friområder og parker."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om grønnstruktur:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=27' target='_blank'>§ 12 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"3001-2": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Fremtidig grønnstruktur"}));
		el.appendChild(creator.createParagraph({text: "Dette er områder som skal tilrettelegges for opplevelse, rekreasjon, lek og fysisk aktivitet for allmennheten.  Dette kan være naturområder, turdrag, friområder og parker."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om grønnstruktur:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=27' target='_blank'>§ 12 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"4001-1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Forsvaret"}));
		el.appendChild(creator.createParagraph({text: "I dette området har Forsvaret har sin militære virksomhet."}));

		return el;
	},
	"5210-1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Eksisterende spredt boligbebyggelse"}));
		el.appendChild(creator.createParagraph({text: "Dette arealet er avsatt til spredt boligbebyggelse."}));

		return el;
	},
	"5210-2": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Fremtidig spredt boligbebyggelse"}));
		el.appendChild(creator.createParagraph({text: "Dette arealet er avsatt til spredt boligbebyggelse."}));

		return el;
	},
	"5100-1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Eksisterende LNF-areal"}));
		el.appendChild(creator.createParagraph({text: "Dette arealet er avsatt til landbruks-, natur- og friluftsområder."}));

		return el;
	},
	"5100-2": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Fremtidig LNF-areal"}));
		el.appendChild(creator.createParagraph({text: "Det arealet er avsatt til landbruks-, natur- og friluftsområder."}));

		return el;
	},
	"5220-1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Eksisterende spredt fritidsbebyggelse"}));
		el.appendChild(creator.createParagraph({text: "Dette arealet er avsatt til spredt fritidsbebyggelse, hvor særskilte krav til lokalisering og utforming kan inngå i planens bestemmelser."}));

		return el;
	},
	"5220-2": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Fremtidig spredt fritidsbebyggelse"}));
		el.appendChild(creator.createParagraph({text: "Dette arealet er avsatt til spredt fritidsbebyggelse."}));

		return el;
	},
	"6001-1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Bruk og vern av sjø og vassdrag med tilhørende strandsone"}));
		el.appendChild(creator.createParagraph({text: "Dette området er avsatt til bruk og vern av sjø og vassdrag."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om bruk og vern av sjø og vassdrag med tilhørende strandsone:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=28' target='_blank'>§ 13 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"6200-1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Farled"}));
		el.appendChild(creator.createParagraph({text: "Dette området er avsatt til farled (ferdselsåre i sjø)."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om farled:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=28' target='_blank'>§ 13 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"6230-1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Eksisterende småbåthavn"}));
		el.appendChild(creator.createParagraph({text: "Dette området er avsatt til eksisterende småbåthavn."}));

		return el;
	},
	"6230-2": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Fremtidig småbåthavn"}));
		el.appendChild(creator.createParagraph({text: "Dette området er avsatt til fremtidig småbåthavn."}));

		return el;
	},
	"6600-1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Naturområde"}));
		el.appendChild(creator.createParagraph({text: "Dette området er avsatt til naturområde i sjøen."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om naturområde:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=28' target='_blank'>§ 13 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"6700-1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Friluftsområde"}));
		el.appendChild(creator.createParagraph({text: "Dette området er avsatt til friluftsområde, som badestrender og områder for padling og roing."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om friluftsområder:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=28' target='_blank'>§ 13 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"H570": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Hensynssoner bevaring kulturmiljø"}));
		el.appendChild(creator.createParagraph({text: "I dette området må det tas spesielle hensyn for å sikre bevaring av kulturmiljøet."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om hensynssoner for bevaring av kulturmiljø:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=30' target='_blank'>§ 15 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"H710": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Hensynssone for båndlegging – naturmiljø, H-710"}));
		el.appendChild(creator.createParagraph({text: "I dette området er det ikke tillatt å bygge noe før en ny arealplan er vedtatt."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om hensynssoner for båndlegging – naturmiljø, H-710:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=30' target='_blank'>§ 16 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"H810_2": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Hensynssone for krav om felles planlegging, H-810-2"}));
		el.appendChild(creator.createParagraph({text: "I dette området er det krav om felles planlegging. Det betyr at det ikke er tillatt å bygge før det er laget en plan for hele området. Kommunen kan likevel gjøre unntak fra kravet for"}));
		el.appendChild(creator.createUl({listItems: [
			"større områder hvor det nylig er vedtatt et planprogram/områdeprogram eller andre veiledende dokument som dekker behovet for felles planlegging",
			"mindre transport- og infrastrukturprosjekter",
			"mindre byggeprosjekter (til- og påbygg, endring/reparasjon av bygning, installasjoner eller anlegg, fasadeendring, bruksendring)"
		]}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om hensynssoner for krav om felles planlegging, H-810-2:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=30' target='_blank'>§ 17.1 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"H810_1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Hensynssoner for krav om godkjent områderegulering, H-810-1"}));
		el.appendChild(creator.createParagraph({text: "Dette er et område med krav om godkjent områderegulering. Det betyr at det ikke er tillatt å bygge før det er vedtatt en områderegulering for hele området. Kommunen kan likevel gjøre unntak fra dette kravet for tiltak og detaljreguleringer som ikke vanskeliggjør påfølgende regulering og utbygging, og som er i samsvar med kommuneplanens bestemmelser og retningslinjer."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om hensynssoner for krav om godkjent områderegulering, H-810-1:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=19' target='_blank'>§ 3 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"H820_1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Hensynssone for høyspentlinje (H-820-1)"}));
		el.appendChild(creator.createParagraph({text: "H-820-1:Høyspentlinjer som skal fornyes eller oppgraderes i dette området, bør legges i jordkabel."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om hensynssoner for høyspentlinjer:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=30' target='_blank'>§ 17.2 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"H820_2": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Hensynssone for trafostasjoner"}));
		el.appendChild(creator.createParagraph({text: "H-820-2: Trafostasjoner som skal etableres eller ombygges i dette området, skal bygges som gassisolerte anlegg hvis det er mulig."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om hensynssoner for trafostasjoner:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=30' target='_blank'>§ 17.2 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"best-marka": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Aktivitetssoner i marka"}));
		el.appendChild(creator.createParagraph({text: "Områder som åpner for tilrettelegging av utendørs aktiviteter og friluftsliv."}));

		return el;
	},
	"1163": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Markagrense"}));
		el.appendChild(creator.createParagraph({text: "Grensen viser hvor markaloven gjelder. Her gjelder et generelt byggeforbud. Bygging her krever tillatelse både fra Fylkesmannen og kommunen."}));

		return el;
	},
	"KpSikringSone-110": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Nedslagsfelt drikkevann"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser hensynssoner rundt drikkevannskilder. Her er det ikke tillatt med tiltak som kan forurense drikkevannet."}));
		el.appendChild(creator.createParagraph({text: "Dagens drikkevannskilder er Maridalsvassdraget, Elvågavassdraget, Langliavassdraget og Alnsjøvassdraget."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om nedslagsfelt for drikkevann:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=29' target='_blank'>§ 14.1 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpSikringSone-190": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Andre sikringssoner <i>H 190-1, -2 og -3</i> (restriksjoner for anlegg i grunnen)"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser hensynssoner med restriksjoner for sprengning og brønnboring, for å sikre eksisterende og fremtidige tunneler."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om områder med restriksjoner for anlegg i grunnen:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=29' target='_blank'>§ 14.2 i kommuneplanen <i class='icon-new-window'></i></a>",
			"<a href='" + kommuneplanDokument + "#page=64' target='_blank'>kommuneplanen kap. 12 om hensynssoner <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpFareSone-310": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Ras- og skredfare (kvikkleire)"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser hensynssoner med mulig fare for større kvikkleireskred (H310_1)."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om kvikkleireskred:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=29' target='_blank'>kommuneplanen § 14.3 første ledd om kvikkleireskred <i class='icon-new-window'></i></a>",
			"<a href='" + kommuneplanDokument + "#page=64' target='_blank'>kommuneplanen kap. 12 om hensynssoner <i class='icon-new-window'></i></a>",
			"<a href='https://od2.pbe.oslo.kommune.no/pages/faktaark/faktaark_kvikkleireskred.html' target='_blank'>faktaark om kvikkleireskred <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpFareSone-310_2": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Ras- og skredfare (steinsprang)"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser hensynssoner hvor det kan være fare for steinsprang (H310_2)."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om steinsprang:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=29' target='_blank'>kommuneplanen § 14.3 andre ledd <i class='icon-new-window'></i></a>",
			"<a href='" + kommuneplanDokument + "#page=64' target='_blank'>kommuneplanen kap. 12 om hensynssoner <i class='icon-new-window'></i></a>",
			"<a href='https://od2.pbe.oslo.kommune.no/pages/faktaark/faktaark_steinsprang.html' target='_blank'>faktaark om steinsprang <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpFareSone-390_1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Flomfare (stormflo)"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser hensynssoner hvor det kan være fare for stormflo (H320_1)."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om stormflo:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=30' target='_blank'>kommuneplanen § 14.4 første ledd om hensynsone stormflo og elveflom <i class='icon-new-window'></i></a>",
			"<a href='" + kommuneplanDokument + "#page=64' target='_blank'>kommuneplanen kap. 12 om hensynssoner <i class='icon-new-window'></i></a>",
			"<a href='" + kommuneplanDokument + "#page=105' target='_blank'>vedlegg 2 til kommuneplanen om ROS-analyse, kapittel 17.2.2 <i class='icon-new-window'></i></a>",
			"<a href='https://od2.pbe.oslo.kommune.no/pages/faktaark/faktaark_stormflo.html' target='_blank'>faktaark om stormflo <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpFareSone-390_2": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Flomfare (elveflom)"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser hensynssoner hvor det kan være fare for elveflom (H320_2)."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om elveflom:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=30' target='_blank'>kommuneplanen § 14.4 første ledd om hensynsone stormflo og elveflom <i class='icon-new-window'></i></a>",
			"<a href='" + kommuneplanDokument + "#page=64' target='_blank'>kommuneplanen kap. 12 om hensynssoner <i class='icon-new-window'></i></a>",
			"<a href='" + kommuneplanDokument + "#page=104' target='_blank'>vedlegg 2 til kommuneplanen om ROS-analyse, kapittel 17.2.1 <i class='icon-new-window'></i></a>",
			"<a href='https://od2.pbe.oslo.kommune.no/pages/faktaark/faktaark_elveflom.html' target='_blank'>faktaark om elveflom <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpFareSone-390": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Annen fare, H-390 (deponi)"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser hensynssonen for forurenset grunn som omfatter de tre tidligere avfallsfyllingene Grønmo, Stubberud og Rommen."}));
		el.appendChild(creator.createParagraph({text: " Her kan du lese mer om deponi:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=30' target='_blank'>kommuneplanen § 14.5 <i class='icon-new-window'></i></a>",
			"<a href='" + kommuneplanDokument + "#page=64' target='_blank'>kommuneplanen kap. 12 om hensynssoner <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpStoySone-Veg-220": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Gul støysone vei"}));
		el.appendChild(creator.createParagraph({text: "I dette området er beregnet støy fra vei L<sub>DEN</sub> 55-65 DB. Her må dere vurdere støyforholdene når dere planlegger nye prosjekter."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om støy:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.1 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpStoySone-Veg-210": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Rød støysone vei"}));
		el.appendChild(creator.createParagraph({text: "I dette området er beregnet støy fra vei L<sub>DEN</sub> > 65 DB. Her må dere vurdere støyforholdene når dere planlegger nye prosjekter."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om støy:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.1 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpStoySone-Bane-220": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Gul støysone bane"}));
		el.appendChild(creator.createParagraph({text: "I dette området er beregnet støy fra bane L<sub>DEN</sub> 58-68 DB. Her må dere vurdere støyforholdene når dere planlegger nye prosjekter."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om støy:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.1 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpStoySone-Bane-210": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Rød støysone bane"}));
		el.appendChild(creator.createParagraph({text: "I dette området er beregnet støy fra bane, L<sub>DEN</sub> > 68 DB. Her må dere vurdere støyforholdene når dere planlegger nye prosjekter."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om støy:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.1 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpStoySone-Havn-220": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Gul støysone havn"}));
		el.appendChild(creator.createParagraph({text: "I dette området er beregnet støy fra havn L<sub>DEN</sub> 50-60 DB (med impulslyd). Her må dere vurdere støyforholdene når dere planlegger nye prosjekter."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om støy:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.1 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpStoySone-Havn-210": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Rød støysone havn"}));
		el.appendChild(creator.createParagraph({text: "I dette området er beregnet støy fra havn L<sub>DEN</sub> > 60 DB (med impulslyd). Her må dere vurdere støyforholdene når dere planlegger nye prosjekter."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om støy:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.1 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpStoySone-Skytebane-220": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Årvoll skytebane - gul sone"}));
		el.appendChild(creator.createParagraph({text: "I dette området er beregnet støy fra skytebane L<sub>AIMAX</sub> 60-70 DB. Her må dere vurdere støyforholdene når dere planlegger nye prosjekter."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om støy:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.1 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpStoySone-Skytebane-210": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Årvoll skytebane - rød sone"}));
		el.appendChild(creator.createParagraph({text: "I dette området er beregnet støy fra skytebane L<sub>AIMAX</sub> > 70 DB (med impulslyd). Her må dere vurdere støyforholdene når dere planlegger nye prosjekter."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om støy:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.1 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"KpStoySone-Avvikssone-290": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Avvikssone"}));
		el.appendChild(creator.createParagraph({text: "I denne sonen kan støyfølsom bebyggelse plasseres i gul/rød sone dersom man oppfyller vilkårene i <a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.1.3 b i kommuneplanen <i class='icon-new-window'></i></a>. Det tillattes ikke nye grunnskoler og barnehager i rød sone"}));

		return el;
	},
	"KpStoySone-230": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Stille områder"}));
		el.appendChild(creator.createParagraph({text: "Stille områder består som regel av friluftsområder, turveier og parker. Dersom dere skal etablere eller utvide støyende virksomhet nær stille områder, må virksomheten plasseres og utformes slik at støynivået forblir uendret eller dempes."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om stille områder:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.1.4 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Luftforurensing-Nitrogendioksid-gronn": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Grønn sone, vintermiddel < 40 µg/m<sup>3</sup>"}));
		el.appendChild(creator.createParagraph({text: "Dette er beregnet konsentrasjon av gassen nitrogendioksid (NO<sub>2</sub>). Fargeskalaen viser tettheten av gassen, hvor grønn er lavest og mørk rød høyest."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om luftforurensing:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.2 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Luftforurensing-Nitrogendioksid-gul": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Gul sone, vintermiddel >= 40 µg/m<sup>3</sup> og årsmiddel < 35 µ/m<sup>3</sup>"}));
		el.appendChild(creator.createParagraph({text: "Dette er beregnet konsentrasjon av gassen nitrogendioksid (NO<sub>2</sub>). Fargeskalaen viser tettheten av gassen, hvor grønn er lavest og mørk rød høyest."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om luftforurensing:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.2 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Luftforurensing-Nitrogendioksid-oransje": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Gul sone, vintermiddel > 40 µg/m<sup>3</sup> og årsmiddel 35 - 40 µ/m<sup>3</sup>"}));
		el.appendChild(creator.createParagraph({text: "Dette er beregnet konsentrasjon av gassen nitrogendioksid (NO<sub>2</sub>). Fargeskalaen viser tettheten av gassen, hvor grønn er lavest og mørk rød høyest."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om luftforurensing:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.2 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Luftforurensing-Nitrogendioksid-rod": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Rød sone, årsmiddel 40 - 45 µg/m<sup>3</sup>"}));
		el.appendChild(creator.createParagraph({text: "Dette er beregnet konsentrasjon av gassen nitrogendioksid (NO<sub>2</sub>). Fargeskalaen viser tettheten av gassen, hvor grønn er lavest og mørk rød høyest."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om luftforurensing:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.2 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Luftforurensing-Nitrogendioksid-mrod": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Rød sone, årsmiddel >= 45 µ/m<sup>3</sup>"}));
		el.appendChild(creator.createParagraph({text: "Dette er beregnet konsentrasjon av gassen nitrogendioksid (NO<sub>2</sub>). Fargeskalaen viser tettheten av gassen, hvor grønn er lavest og mørk rød høyest."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om luftforurensing:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.2 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Luftforurensing-Svevestøv-gronn": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Grønn sone < 35 µg/m<sup>3</sup>"}));
		el.appendChild(creator.createParagraph({text: "Dette er beregnet konsentrasjon av svevestøv. Fargeskalaen viser tettheten, hvor grønn er lavest og mørk rød høyest."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om luftforurensing:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.2 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Luftforurensing-Svevestøv-gul": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Gul sone 35 - 44 µg/m<sup>3</sup>"}));
		el.appendChild(creator.createParagraph({text: "Dette er beregnet konsentrasjon av svevestøv. Fargeskalaen viser tettheten, hvor grønn er lavest og mørk rød høyest."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om luftforurensing:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.2 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Luftforurensing-Svevestøv-oransje": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Gul sone 45 - 49 µg/m<sup>3</sup>"}));
		el.appendChild(creator.createParagraph({text: "Dette er beregnet konsentrasjon av svevestøv. Fargeskalaen viser tettheten, hvor grønn er lavest og mørk rød høyest."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om luftforurensing:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.2 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Luftforurensing-Svevestøv-rod": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Rød sone 50 - 54 µg/m<sup>3</sup>"}));
		el.appendChild(creator.createParagraph({text: "Dette er beregnet konsentrasjon av svevestøv. Fargeskalaen viser tettheten, hvor grønn er lavest og mørk rød høyest."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om luftforurensing:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.2 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Luftforurensing-Svevestøv-mrod": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Rød sone >= 55 µg/m<sup>3</sup>"}));
		el.appendChild(creator.createParagraph({text: "Dette er beregnet konsentrasjon av svevestøv. Fargeskalaen viser tettheten, hvor grønn er lavest og mørk rød høyest."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om luftforurensing:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=23' target='_blank'>§ 7.2 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Naturmiljø-bandlegging_pbl": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Båndlegging for regulering etter plan- og bygningsloven"}));
		el.appendChild(creator.createParagraph({text: "Dette er områder som kommuneplanen båndlegger i påvente av avklaringer av fremtidig arealbruk. Dette skjer gjennom reguleringsplan etter plan- og bygningsloven."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om båndlegging – naturmiljø, H-710:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=24' target='_blank'>§ 7.6 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Naturmiljø-vern_markalvn": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Områder vernet etter markaloven"}));
		el.appendChild(creator.createParagraph({text: "Dette er områder som er vernet etter markaloven."}));

		return el;
	},
	"Naturmiljø-vern_naturmangfoldlv": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Områder vernet etter naturmangfoldloven"}));
		el.appendChild(creator.createParagraph({text: "Dette er områder som er vernet etter naturmangfoldloven."}));

		return el;
	},
	"Naturmiljø-natur_a": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Naturtyper A-områder"}));
		el.appendChild(creator.createParagraph({text: "Dette er naturmiljøer med nasjonal verdi, og det er ikke tillatt med tiltak som kan skade naturverdiene."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om naturtyper A-områder:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=24' target='_blank'>§ 7.6 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Naturmiljø-natur_b": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Naturtyper B-områder"}));
		el.appendChild(creator.createParagraph({text: "Dette er naturmiljøer med regional verdi, og det skal særlige grunner til å tillate tiltak som kan skade naturverdiene."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om naturtyper B-områder:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=24' target='_blank'>§ 7.6 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Naturmiljø-natur_c": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Naturtyper C-områder"}));
		el.appendChild(creator.createParagraph({text: "Dette er naturmiljøer med lokal verdi, og tiltak som kan skade naturverdiene, bør unngås."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om naturtyper C-områder:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=24' target='_blank'>§ 7.6 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Naturmiljø-regulert_natur": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Områder regulert til naturvernområder/naturområder/naturmiljø"}));
		el.appendChild(creator.createParagraph({text: "Dette er områder som er sikret gjennom reguleringsplan etter plan- og bygningsloven."}));

		return el;
	},
	"Kulturminnevern-nasjonale_kulturminneinteresser": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Områder med nasjonale kulturminneinteresser"}));
		el.appendChild(creator.createParagraph({text: "I områder med nasjonal kulturminneinteresse er målet å ta vare på bevaringsverdiene. Saksbehandlingen vil avklare graden av bevaring. Nye bygninger som grenser til bygg eller anlegg med nasjonal verneverdi, bør plasseres og utformes slik at man viderefører viktige elementer i eksisterende gate-, byroms- og bebyggelsesstruktur. Eksempler på områder: Kvadraturen, Kampen og Ullevål Hageby."}));
		el.appendChild(creator.createParagraph({text: "Eksempler: Kvadraturen, Kampen, Ullevål Hageby, Slottet og Stortinget."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om kategori 1 indre by:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=24' target='_blank'>§ 8 i kommuneplanen <i class='icon-new-window'></i></a>",
			"<a href='" + kommuneplanDokument + "#page=20' target='_blank'>§ 3.2 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Kulturminnevern-grense_indre_by": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Avgrensning indre by"}));
		el.appendChild(creator.createParagraph({text: "Områdene innenfor denne avgrensningen defineres som indre by. Områdene utenfor defineres som ytre by."}));

		return el;
	},
	"Kulturminnevern-hensyn_bevaring_kulturmiljo": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Hensynssone bevaring kulturmiljø"}));
		el.appendChild(creator.createParagraph({text: "Denne kategorien inneholder spesielt verdifulle bygningsmiljøer på Majorstuen–Fagerborg, Bislett–St. Hanshaugen–Ila og Grünerløkka–Sofienberg. I disse områdene er målet å sikre kulturminneinteressene. Nye tiltak skal derfor plasseres og utformes slik at man viderefører viktige elementer i eksisterende gate-, byroms- og bebyggelsesstruktur. Bygninger med nasjonalt og regionalt viktige kulturminneverdier bør bevares."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om hensynssone bevaring kulturmiljø:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=30' target='_blank'>§ 15 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Kulturminnevern-nasjonale_kulturminner": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Avklarte nasjonale kulturminner"}));
		el.appendChild(creator.createParagraph({text: "Denne kategorien omfatter bygninger og anlegg med avklart nasjonal verdi som skal bevares. Nasjonal verneverdi kan være nasjonale vernevedtak, statlig listeføring eller automatisk fredning."}));
		el.appendChild(creator.createParagraph({text: "Eksempler: Frognerparken, Trefoldighetskirken og Birkelunden."}));

		return el;
	},
	"Kulturminnevern-nasjonale_kulturminner_bygg": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Avklarte nasjonale kulturminner (bygninger)"}));
		el.appendChild(creator.createParagraph({text: "Denne kategorien omfatter bygninger og anlegg med avklart nasjonal verdi som skal bevares. Nasjonal verneverdi kan være nasjonale vernevedtak, statlig listeføring eller automatisk fredning."}));

		return el;
	},
	"Kulturminnevern-regulert_bevaring": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Områder regulert til bevaring"}));
		el.appendChild(creator.createParagraph({text: "Hensikten med å regulere et område til bevaring er å sikre kulturminneverdiene området. I områder som er regulert til bevaring, er det egne reguleringsplaner med bestemmelser som legger føringer for hvilke endringer som kan tillates på eksisterende bebyggelse. I noen tilfeller sier bestemmelsene også noe om hvilke typer nybygg som kan tillates i området. Områder som er regulert til bevaring, er vernet etter plan- og bygningsloven og har dermed et formelt vern."}));

		return el;
	},
	"Kulturminnevern-vern_indre_kat1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Områder med verneverdi i indre by. Kategori 1 indre by"}));
		el.appendChild(creator.createParagraph({text: "I områdene i denne kategorien er målet å sikre bevaringsverdiene. Det betyr at nye tiltak bør plasseres og utformes på en måte som gjør at man viderefører viktige elementer i eksisterende gate-, byroms-, og bebyggelsesstrukturer."}));
		el.appendChild(creator.createParagraph({text: "Eksempler: NRK på Marienlyst og Vår frelsers gravlund."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om kategori 1 indre by:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=24' target='_blank'>§ 8 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Kulturminnevern-vern_ytre_kat1": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Områder med verneverdi i ytre by. Kategori 1 ytre by"}));
		el.appendChild(creator.createParagraph({text: "I disse områdene er målet å sikre bevaringsverdiene. Det betyr at nye tiltak bør plasseres og utformes på en måte som gjør at man viderefører viktige elementer i eksisterende gate-, byroms- og bebyggelsesstrukturer."}));
		el.appendChild(creator.createParagraph({text: "Eksempler: Ammerud og Husebygrenda."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om kategori 1 ytre by:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=24' target='_blank'>§ 8 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Kulturminnevern-vern_ytre_kat2": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Kategori 2 ytre by"}));
		el.appendChild(creator.createParagraph({text: "I disse områdene er målet å ta vare på bevaringsverdiene samtidig som områdene skal videreutvikles. Hensynet til bevaring skal veies opp mot andre hensyn i plan- og bygningsloven."}));
		el.appendChild(creator.createParagraph({text: "Eksempler: Lambertseter, Ekeberg–Nordstrand."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om kategori 2 ytre by:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=24' target='_blank'>§ 8 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"Storulykke-brann_og_eksplosjon": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Storulykkebedrifter"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser områder med særlig stor brann- og eksplosjonsfare rundt storulykkebedrifter. En storulykkevirksomhet er en virksomhet hvor det arbeides med giftige og farlige kjemikalier over en viss mengde. Størrelsen på sonene varierer og bygger på en faglig vurdering av hver enkelt virksomhet innenfor rammene av gjeldende lovverk."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om storulykkebedrifter:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=25' target='_blank'>§ 9.2 i kommuneplanen <i class='icon-new-window'></i></a>",
			"<a href='https://od2.pbe.oslo.kommune.no/pages/faktaark/faktaark_storulykke.html' target='_blank'>faktaark om storulykker <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"blaagronn-viktige_kommunikasjonsaarer": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Viktige kommunikasjonsårer med eksisterende og nye trær"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser strekninger hvor det skal tas vare på eksisterende trær eller plantes nye trær dersom det er mulig."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om viktige kommunikasjonsårer med eksisterende og nye trær:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=28' target='_blank'>§ 13.3 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"blaagronn-elv_bekk_vann_dam": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Elv, bekk, vann, dam"}));
		el.appendChild(creator.createParagraph({text: "Åpne strekninger av elver, bekker, vann og dammer skal opprettholdes."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om vassdrag:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=28' target='_blank'>§ 13.3 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"blaagronn-hovedturvei_eksisterende": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Hovedturvei"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser tre kategorier av turvei:"}));
		el.appendChild(creator.createUl({listItems: [
			"<i>eksisterende turvei</i> som enten er opparbeidet eller regulert",
			"<i>fremtidig turvei</i> som forutsettes sikret ved byutvikling",
			"<i>annen viktig gangforbindelse</i> som ikke er mulig å opparbeide til et sammenhengende grønt område med tursti (turdrag), men som likevel er viktig å opparbeide fremover for å sikre sammenheng i turveinettet."
		]}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om hovedturvei:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=27' target='_blank'>§ 12.3 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"blaagronn-hovedturvei_framtidig": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Hovedturvei"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser tre kategorier av turvei:"}));
		el.appendChild(creator.createUl({listItems: [
			"<i>eksisterende turvei</i> som enten er opparbeidet eller regulert",
			"<i>fremtidig turvei</i> som forutsettes sikret ved byutvikling",
			"<i>annen viktig gangforbindelse</i> som ikke er mulig å opparbeide til et sammenhengende grønt område med tursti (turdrag), men som likevel er viktig å opparbeide fremover for å sikre sammenheng i turveinettet."
		]}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om hovedturvei:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=27' target='_blank'>§ 12.3 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"blaagronn-annen_viktig_gangforbindelse": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Hovedturvei"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser tre kategorier av turvei:"}));
		el.appendChild(creator.createUl({listItems: [
			"<i>eksisterende turvei</i> som enten er opparbeidet eller regulert",
			"<i>fremtidig turvei</i> som forutsettes sikret ved byutvikling",
			"<i>annen viktig gangforbindelse</i> som ikke er mulig å opparbeide til et sammenhengende grønt område med tursti (turdrag), men som likevel er viktig å opparbeide fremover for å sikre sammenheng i turveinettet."
		]}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om hovedturvei:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=27' target='_blank'>§ 12.3 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"blaagronn-turdrag_prinsipp": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Fremtidig turdrag – prinsipptrasé"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser områder som gjennom byutvikling skal utvikles til sammenhengende grønnstrukturer med tursti (turdrag), slik at natur- og landskapskvaliteter videreutvikles og økologiske sammenhenger styrkes."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om turdrag:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=27' target='_blank'>§ 12.3 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"blaagronn-park_1daa": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Områder med behov for park på minst 1 daa"}));
		el.appendChild(creator.createParagraph({text: "Hvis det bygges prosjekter som enkeltvis eller samlet omfatter 20 000 m² BRA eller mer i disse områdene, bør det etableres park på minst 1 dekar."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om områder med behov for park:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=27' target='_blank'>§ 12.3 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"blaagronn-park_5daa": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Områder med behov for park på minimum 5 daa"}));
		el.appendChild(creator.createParagraph({text: "Hvis det bygges prosjekter som enkeltvis eller samlet omfatter 40 000 m² BRA eller mer i disse områdene, bør det etableres park på minst 5 dekar."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om områder med behov for park:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=27' target='_blank'>§ 12.3 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"blaagronn-krysningspunkt_tiltak": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Krysningspunkt som krever tiltak"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser steder der turveier krysser trafikkerte veier. Her skal det sikres trafikksikker krysning som gir prioritet til turveien."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om krysningspunkt:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=27' target='_blank'>§ 12.3 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"blaagronn-elv_bekk_prinsipp": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Fremtidig elv/bekk – prinsipptrasé"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser elver og bekker som bør gjenåpnes."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om elver og bekker som bør gjenåpnes:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=28' target='_blank'>§ 13.3 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	},
	"blaagronn-park_prinsipp": function () {
		var el = creator.createDiv({});
		el.appendChild(creator.createH3({text: "Fremtidig park – prinsipplassering"}));
		el.appendChild(creator.createParagraph({text: "Plankartet viser områder hvor det planlegges park, og prinsipplassering er avklart."}));
		el.appendChild(creator.createParagraph({text: "Her kan du lese mer om plassering av fremtidig park:"}));
		el.appendChild(creator.createUl({listItems: [
			"<a href='" + kommuneplanDokument + "#page=27' target='_blank'>§ 12.3 i kommuneplanen <i class='icon-new-window'></i></a>"
		]}));

		return el;
	}
};

export default {
	getInfoTextFor: function (id) {
		var helpTextId;
		if (id.indexOf("1001-2") >= 0) {
			helpTextId = "1001-2";
		} else {
			helpTextId = id;
		}
		return privateFns[helpTextId];
	}
};
